(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  function init(scope = document) {
    scope.querySelectorAll('[data-site-header]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const searchButton = root.querySelector('[data-search-toggle]');
      const searchPanel = root.querySelector('[data-search-panel]');
      const menuButton = root.querySelector('.menu-toggle');
      const menu = root.querySelector('.mobile-nav');
      function closeMenus() { root.querySelectorAll('.nav-dropdown[open]').forEach(item => { item.open = false; }); }
      function setMenu(open) { menu.hidden = !open; menuButton.setAttribute('aria-expanded', String(open)); }
      function setSearch(open, restoreFocus = false) {
        searchPanel.hidden = !open;
        searchButton.setAttribute('aria-expanded', String(open));
        if (open) { setMenu(false); closeMenus(); searchPanel.querySelector('input[type=search]').focus(); }
        else if (restoreFocus) searchButton.focus();
      }
      searchButton.addEventListener('click', () => setSearch(searchPanel.hidden));
      root.querySelector('[data-search-close]').addEventListener('click', () => setSearch(false, true));
      menuButton.addEventListener('click', () => { const open = menu.hidden; setSearch(false); closeMenus(); setMenu(open); });
      root.addEventListener('click', event => {
        const summary = event.target.closest('.nav-dropdown>summary');
        if (summary) {
          setSearch(false);
          root.querySelectorAll('.nav-dropdown[open]').forEach(item => { if (item !== summary.parentElement) item.open = false; });
        }
        if (event.target.closest('nav a')) { setMenu(false); closeMenus(); }
      });
      root.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        if (!searchPanel.hidden) { setSearch(false, true); return; }
        const dropdown = event.target.closest('.nav-dropdown[open]');
        if (dropdown) { dropdown.open = false; dropdown.querySelector('summary').focus(); return; }
        if (!menu.hidden) { setMenu(false); menuButton.focus(); }
        closeMenus();
      });
      document.addEventListener('click', event => { if (!root.contains(event.target)) { setSearch(false); setMenu(false); closeMenus(); } });
      root.addEventListener('focusout', event => { if (event.relatedTarget && !root.contains(event.relatedTarget)) { setSearch(false); setMenu(false); closeMenus(); } });
      window.matchMedia('(min-width: 961px)').addEventListener('change', () => { setMenu(false); closeMenus(); });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
